import React, { Component } from 'react'

class agendapage extends Component {
  render () {
    return (
      <div>
        <h1>Agenda</h1>
      </div>
    )
  }
}

export default agendapage



// WEBPACK FOOTER //
// ./src/components/agendapage.js